import { replace, LOCATION_CHANGE } from 'connected-react-router';
import { createMiddleware } from '@shared/redux';
import ACCOUNT_SELECTOR_CONSTANTS from '@shared/constants/accountSelector.constants';
import {
    getAlerts, HANDLE_GET_ALERTS, handleGetAlerts, setAlert,
} from './alert.state';
import { GET_OBJECT_SELECTED } from '../_redux/pareto-ads-app-redux/action/actionTypes';
import { getUser } from '../auth';


const getParamsForGetAlert = (state, objectSelected) => {
    const {
        account_selected: accountSelected,
        client_selected: clientSelected,
    } = objectSelected;

    const selectedId = clientSelected.selected
        ? { client_id: clientSelected.id } : { account_id: accountSelected.id };

    const location = state.router.location.pathname.split('/');
    const page = location[location.length - 1];

    return {
        page,
        ...selectedId,
    };
};


const onAllowedActionTypeReceived = (type, action, objectSelected, store, state) => {
    const currentObjectSelected = type === GET_OBJECT_SELECTED
        ? action.objectSelected : objectSelected;

    const params = new URLSearchParams(window.location.search);
    const alertKeyMessageFromUrl = params.get('error');

    if (alertKeyMessageFromUrl) {
        store.dispatch(
            setAlert(alertKeyMessageFromUrl),
        );
        store.dispatch(replace(window.location.pathname));
    } else if (getUser(store.getState())) {
        store.dispatch(
            handleGetAlerts(getParamsForGetAlert(state, currentObjectSelected)),
        );
    }
};

export const updateRouterLocationMiddleware = store => next => (action) => {
    const nextAction = next(action);
    const { type } = action;
    const state = store.getState();
    const { data } = state;
    const { objectSelected } = data;

    if (objectSelected.loadingObjectSelected === true) {
        return nextAction;
    }

    const allowedActionTypes = [
        LOCATION_CHANGE,
        GET_OBJECT_SELECTED,
    ];

    if (allowedActionTypes.includes(type)) {
        onAllowedActionTypeReceived(type, action, objectSelected, store, state);
    }

    return nextAction;
};

export const alertsMiddleware = createMiddleware({
    [HANDLE_GET_ALERTS]: (state, action) => {
        const { params } = action?.payload;
        const { client_id: clientId, account_id: accountId } = params;
        const isAllAccounts = clientId === ACCOUNT_SELECTOR_CONSTANTS.ALL_ACCOUNTS
            || accountId === ACCOUNT_SELECTOR_CONSTANTS.ALL_ACCOUNTS;
        if (!isAllAccounts) {
            return [getAlerts(params)];
        }
        return [];
    },
});
